import PLURAL_KOEF from '@/constants/nameGeneration/PLURAL_KOEF'

export default () => Math.random() <= PLURAL_KOEF
